export { FormControl } from './component';

export type { Props as FormControlProps } from './types';
